import { gql } from '@apollo/client';

const CREATE_READ_BOOK_EVENT = gql`
  mutation createReadBookEvent($data: ReadBookEventCreateInput!) {
    createReadBookEvent(data: $data)
  }
`;

export default CREATE_READ_BOOK_EVENT;
